import React from 'react';

const DragHandle = () => {
  return (
      <div className="drag-handle">
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
      </div>
  )
};

export default DragHandle;



// WEBPACK FOOTER //
// ./src/components/drag-handle/drag-handle.jsx